import settings from "../../settings";

export const TRANSLATION_EN = {
    common: {
        reset: 'Reset',
        vlmAcronym: 'VLM',
        vlmLabel: '(Vendor Lifecycle Management)',
        loading: 'Loading...',
        accept: "Accept",
        success: "Success",
        buttonActions: {
            services: {
                addServices: 'Add services'
            },
            fleet: {
                modifyFleet: 'Modify fleet'
            },
            routes: {
                addRoutes: 'Add routes'
            },
            addVehicle: "Add Vehicle",

        },
        menu: {
            dashboard: 'Dashboard',
            services: 'Services',
            documents: 'Documents',
            contracts: 'Contracts',
            trips: 'Trips',
            fleetAndRoute: 'Fleet & Route',
            settings: 'Settings',
            app: 'Go to App'
        },
        errors: {
            engineTypePercent: 'Engine type must be of sum 100.',
            emissionClassPercent: 'Emission class must be of sum 100.',
            addingRoutes: 'Error adding routes.',
            zeroVehicles: "You have to enter at least one vehicle",
            mandatoryField: "Mandatory Field"
        },
        sidebars: {
            addDriver: {
                heading: 'Add Driver',
                paragraph: 'General Data',
                name: 'Name',
                addName: 'Insert Name',
                surname: 'Surname',
                addSurname: 'Insert Surname',
                phone: 'Phone',
                addPhone: 'Insert Phone',
                pIva: "P.IVA",
                addPIva: 'Insert P.IVA',
                email: 'Email',
                addEmail: 'Insert Email',
                info: 'Fields Are Mandatory',
                button: 'Add Driver',
                driverStatus: 'Driver Status',
                invalidEmail: "Please enter a valid email",
                add: 'Add'
            },
            saveButtonText: "Save",
            addServices: {
                heading: 'Add Services',
                button: 'Add services',
                goBack: 'Back'
            },
            addVehicle: {
                heading: 'Add Vehicle',
                button: 'Add Vehicle',
                paragraph: 'General Data',
                vehiclePlate: "Vehicle Plate",
                addVehiclePlate: 'Enter plate',
                addPlate: 'Add plate',
                fleetType: "Vehicle Type",
                addFleetType: 'Enter vehicle type',
                categoryType: "Category Type",
                addCategoryType: 'Enter category type',
                registrationDate: "Registration Date",
                addRegistrationDate: 'Enter registration date',
                vehicleDocument: "Vehicle Registration Document",
                addVehicleDocument: 'Upload document',
                environmentalClassEuro: "Emission Class ",
                selectEnvironmentalClassEuro: 'Select Euro environmental class',
                fuelType: "Fuel Type",
                addFuelType: 'Enter fuel type',
                emissionData: "Emission Data",
                addEmissionData: 'Enter emission data',
                vectoDeclaration: "VECTO Declaration",
                addVectoDeclaration: 'Enter VECTO declaration',
                info: '*Fields are mandatory',
                sustainabilityData: 'Sustainability Data',
                vehicleStatus: 'Vehicle Status',
                remove: 'Remove',
                selectData: 'Select Data',
                add: 'Add',
                loadCapacity: "Load Capacity",
                loadCapacityUDM: "Load Capacity UDM",
                modify: 'Modify',
                mandatoryField: 'Mandatory Field',
                saveChanges: "Save changes",
                vehicle: 'Vehicle',
                untrackablePlateWithTrips: "License plate {{licensePlate}} associated with trip:",
                untrackablePlate: "License plate {{licensePlate}} is reported as untrackable by {{platform}}",
                isReportedAsUntrackable: "is reported as untrackable by {{platform}}",
                unassociatedPlate: "License plate not associated with any Driver. For traction services, associate the plate with a driver or select another plate"
            },
            addAssociations: {
                plate: "Plate",
                vehicle: 'Vehicle Type',
                startDate: 'Starting Date',
                endDate: 'Ending Date',
                insertPlate: 'Insert Plate',
                newAssociation: 'New Association',
                addNew: 'Add New Association',
                save: 'Save',
                cancel: 'Cancel',
                vehicleAssociation: 'Association State',
                modifyAssociation: 'Modify Association',
                dateOverlapError: "The selected dates have conflicts",
            },
            modifyFleet: {
                heading: 'Modify fleet',
                subParts: {
                    typeOfEngine: {
                        heading: 'Type of engine',
                        paragraph: 'You have a total of <strong>{{count_vehicles}}</strong> vehicles. Please, indicate a percentage for type of engine of your fleet:'
                    },
                    emissionClass: {
                        heading: 'Emission class',
                        paragraph: 'Based on the type of engine, please indicate the class of emission.'
                    }
                }
            },
            addRoutes: {
                heading: 'Add routes',
                stepOne: {
                    heading: 'Select from',
                    paragraph: 'Chose a country by clicking on the map. You can also start typing in the input field and select from the menu.',
                    selectLabel: 'From',
                    selectPlaceholder: 'Insert country',
                    button: 'Proceed to step 2'
                },
                stepTwo: {
                    heading: 'Select to',
                    paragraph: 'Chose the countries by clicking on the map. You can also add countries by typing in the input field. Define if One-way or Roundtrip for each route.',
                    selectToLabel: 'To',
                    selectToPlaceholder: 'Insert country',
                    selectTypeLabel: 'Type',
                    selectTypePlaceholder: 'Insert type',
                    button: 'Confirm routes'
                },
            },
            addDocument: {
                heading: 'Add Document',
                dragNDropText: 'Drag and drop or click to upload',
                document: 'Document'
            },
            addContractDocument: {
                heading: "Upload document",
                loading: 'Loading...',
                submit: "Submit document",
                document: "Document",
                dragNDropText: "Drag & Drop your document here or click to chose a document from your device."
            },
            addUser: {
                heading: "Add user",
                name: "Name",
                surname: "Surname",
                email: "Email",
                confirmEmail: "Confirm email",
                phone: "Phone",
                role: "Role"
            },
            modifyUser: {
                heading: "Modify user",
                name: "Name",
                surname: "Surname",
                email: "Email",
                confirmEmail: "Confirm email",
                phone: "Phone",
                role: "Role"
            },
            notifications: {
                heading: "Notifications",
                seeAllNotifications: "See all read notifications",
                emptyNotificationsToRead: "There's no notification to read.",
                emptyNotifications: "There's no read notification to show."
            }
        }


    },
    screens: {
        dashboard: {
            welcomeGreeting: 'Hello',
            subHeading: 'This is your status',
            widgets: {
                services: {
                    heading: 'My Services',
                    status: 'Status',
                    additionalServices: 'Additional services',
                    additionalServiceSingular: 'Additional service',
                    link: 'Go to services'
                },
                fleet: {
                    heading: 'My Fleet',
                    engineType: 'Engine type',
                    emissionClass: 'Emission class',
                    link: 'Go to fleet'
                },
                registeredFleet: {
                    heading: 'My Fleet',
                    engineType: 'Engine type registered',
                    emissionClass: 'Emission class registered',
                    link: 'Go to fleet',
                    vehicles: 'Vehicles',
                    trailers: 'Trailers'
                },
                documents: {
                    heading: 'My Documents',
                    button: 'Check documents',
                    link: 'Go to documents',
                    documentPrefixes: {
                        plural: 'documents',
                        singular: 'document'
                    }
                },
                routes: {
                    heading: 'My Routes',
                    link: 'Go to routes'
                },
                contracts: {
                    heading: 'My Contracts',
                    otherContract: "active contract",
                    otherContracts: "active contract",
                    toBeAcceptedContract: "contract to be accepted",
                    toBeAcceptedContracts: "contracts to be accepted",
                    link: 'Go to contracts',
                    bankDataMissing: "Insert your bank details to enable payments for your invoices"
                },
                trips: {
                    heading: 'My Trips',
                    button: "Check trips",
                    link: 'Go to trips',
                    tripPrefixes: {
                        singular: 'Trip',
                        plural: 'Trips'
                    },
                    kpi: {
                        1: "without plate",
                        2: "not approved",
                        3: "waiting for documentation",
                    },

                }
            }
        },
        services: {
            heading: 'Services',
            tabMainServices: 'Main services',
            tabAdditionalServices: 'Additional services',
            emptyServices: 'There are no services to show.',
            filter: 'Filter',
            allServices: 'All services',
            tableHeaders: {
                category: 'Category',
                serviceType: 'Service Type',
                info: 'Info',
                status: 'Status'

            }
        },
        documents: {
            heading: 'Documents',
            emptyDocuments: 'There are no documents to show.',
            filter: 'Filter',
            allDocuments: 'All documents',
            nDocuments: '{{value}} documents',
            downloadTemplate: 'download template',
            validUntil: 'Valid until ',
            uploaded: 'Last uploaded',
            note: 'Note',
            uploadRequested: 'Mandatory upload',
            uploadNotMandatory: "Optional upload",
            acceptanceRequest: 'Acceptance request',
            updateRequested: 'Update requested',
            uploadTemplate: 'Upload template',
            uploadNewVersion: 'Upload new version',
            uploadTemplateText: "You need to download and fill the template. Then proced to upload the document in the required format.",
            updateRequestedText: "You have <strong>{{days_before_blocking}}</strong> days to upload an updated version of the document before the service will be deactivated.",
            uploadRequestedText: "The document is required for the activation of the services.",
            uploadMultipleRequestedText: "One or more documents are required for the activation of the service",
            tableHeaders: {
                category: 'Category',
                type: 'Type',
                subType: 'Sub Type',
                uploaded: 'Uploaded',
                validUntil: 'Valid until ',
                status: 'Status',
                action: 'Action',
                note: 'Note',
                name: "Document name"
            }
        },
        contracts: {
            heading: 'Contracts',
            emptyContracts: 'There are no contracts to show.',
            iban: 'Iban',
            swift: "Swift",
            paymentTerms: 'Payment Terms',
            filter: 'Filter',
            allContracts: 'All contracts',
            validUntil: 'Valid until ',
            signed: 'Signed',
            signRequested: 'Sign requested',
            signRequestedText: 'The contract need to be signed. Check your mail for instructions.',
            actionRequired: 'Action required',
            acceptanceRequested: 'Acceptance requested',
            acceptanceRequestedText: "Please click on the document link to accept for viewing.",
            insertBankData: "Insert bank details",
            tableHeaders: {
                contract: 'Contract',
                legalRepresentative: 'Legal Representative',
                paymentTerms: 'Payment Terms',
                signed: 'Signed',
                validUntil: 'Valid until ',
                status: 'Status',
                note: 'Note'
            },
            isUnderEvaluation: "Under evaluation",
        },
        trips: {
            heading: 'Trips',
            showMore: 'Show more',
            showMoreTrips: 'Show more trips',
            noLicense: 'No License',
            filters: {
                filters: 'Filter',
                status: 'Status',
                approval: 'Approval',
                date: 'Date',
                dateRange: 'Date Range',
                filter: 'Filter'
            },
            columnDef: {
                status: 'Status',
                approval: 'Approval',
                loadDate: 'Load Date',
                unloadDate: 'Unload Date',
                expectedDeparture: 'Expected Departure',
                expectedArrival: 'Expected Arrival',
                tractorLicensePlate: 'Tractor Plate',
                trailerLicensePlate: 'Trailer Plate',
                loadingLocation: 'Loading Location',
                unloadingLocation: 'Unloading Location',
                documents: 'Documents',
                trip: "Trip",
                creationMilestone: 'Creation Milestone'
            },
            tripDialog: {
                tripApproval: 'Trip Approval',
                tripRejection: "Trip Rejection",
                approve: 'approve',
                reject: 'reject',
                approveTrip: 'Approve Trip',
                rejectTrip: 'Reject Trip',
                doYouWantTo: 'Do you want to',
                thisTrip: 'this trip ?',
                confirmSaveChanges: 'Save the changes ?',
                saveOrDiscardChanges: 'Do you want to save the updated value or discard the changes ?',
                save: 'Save',
                cancel: 'Cancel',
                reject2: 'reject',
                approve2: 'approve'
            },
            chips: {
                planner: 'PLANNER',
                firstDriver: 'FIRST DRIVER',
                tpSpecialist: 'TP SPECIALIST',
                email: 'EMAIL',
                phone: 'PHONE'
            },
            oriDest: {
                origin: 'ORIGIN',
                destination: 'DESTINATION',
                downloadTransportDocument: 'DOWNLOAD TRANSPORT ORDER',

            },
            loadCard: {
                weight: 'WEIGHT',
                volume: 'VOLUME',
                shipUnitCount: 'SHIP UNIT COUNT',
                linearMeters: 'LINEAR METERS',
                load: 'LOAD'
            },
            datesCard: {
                dates: 'DATES',
                departure: 'DEPARTURE',
                arrival: 'ARRIVAL',
                expectedDeparture: 'EXPECTED DEPARTURE',
                expectedArrival: 'EXPECTED ARRIVAL',
                actualDeparture: 'ACTUAL DEPARTURE',
                actualArrival: 'ACTUAL ARRIVAL',
                assignedDate: 'ASSIGNED DATE'
            },
            documentsCard: {
                allTransportDocuments: 'ALL TRANSPORT DOCUMENTS',
                checkAllDocuments: 'CHECK ALL DOCUMENTS',
                generalConditions: 'GENERAL CONDITIONS'
            },
            notesCard: {
                notes: 'NOTES',
                allNotes: 'ALL NOTES',
                noNotes: 'No notes',
                note: 'Note',
                noNotesAvailable: 'No notes available',
                note1: 'NOTE 1',
                note2: 'NOTE 2'
            },
            licensePlate: {
                saveChanges: "Save Changes",
                saveOrDiscard: 'Do you want to save or discard the changes ?',
                cancel: 'Cancel',
                save: 'Save',
                error: 'Error during editing',
                editCanceled: 'Edit canceled',
                success: 'Plate updated succesfully'
            },
            timeline: {
                from: 'FROM',
                to: 'TO',
                mandatory: 'MANDATORY',
                noStops: 'No stops available',
                loadingPoint: 'Loading point',
                addPod: 'ADD POD / CMR',
                selectLoadingPoint: 'Select loading point',
                selectLoadingPointFirst: 'Select a loading point first',
                documentAlreadyExists: 'Document already exists for this loading point',
                noLoadingPoints: 'No loading points available'
            },
            mobileCard: {
                tripMap: 'TRIP MAP',
                tripTimeline: "TRIP TIMELINE"
            },
            tripDocuments: {
                back: "Back to Trip Details",
                addDocument: "Add Document",
                uploaded: "Uploaded on",
                by: "by",
                description: 'Description',
                document: "Document",
                documents: "Documents",
                additionalAttachments: "Additional attachments",
                generalConditions: 'General Conditions',
                podMandatoryUpload: "POD MANDATORY UPLOAD",
                documentRejected: 'DOCUMENT REJECTED',
                insertDocumentError: 'License plate already present or incorrect data',
                updateDocumentError: 'Error during vehicle update'
            },
            tripDocumentPage: {
                trip: "TRIP"
            },
            approval: {
                on: 'on ',
                by: 'by '
            },
            statusOptions: {
                ASSIGNED: "Assigned",
                ALLOCATED: "Allocated",
                IN_PROGRESS: "In Progress",
                WAITING_FOR_DOCUMENTATION: "Waiting for documentation",
                COMPLETED: "Completed"
            },
            approvalStatus: {
                APPROVED: "Approved",
                REJECTED: "Rejected",
                TO_APPROVE: "To approve",
                AUTO_ACCEPTED: "Auto accepted",
                TO_BE_EVALUATED: 'To be evaluated',
                TO_BE_UPLOADED: 'To be uploaded',
                ACCEPTED: 'ACCEPTED'
            },
            approvalStatusDoc: {
                APPROVED: "Approved",
                REJECTED: "Rejected",
                TO_APPROVE: "To approve",
                AUTO_ACCEPTED: "Auto accepted",
                TO_BE_EVALUATED: 'To be evaluated',
                TO_BE_UPLOADED: 'To be uploaded',
                ACCEPTED: 'ACCEPTED'
            },
            position: {
                notAvailable: 'Position Not Available'
            },
            agGrid: {
                pageSize: 'Page Size',
                page: "Page",
                nextPage: "Next Page",
                previousPage: "Previous Page",
                lastPage: "Last Page",
                firstPage: "First Page",
                ariaPaginationPage: "Page",
                ariaPagination: "Pagination",
                ariaLabelPagination: "Pagination navigation",
                rangeSelectionEmpty: "No data available",
                paginationSummary: "Showing {firstRow}-{lastRow} of {rowCount}",
                empty: "Empty",
                loadingOoo: "Loading in progress...",
                to: 'to',
                of: 'of'
            },
            mapLegend: {
                Legend: "Legend",
                actualPosition: "Actual Position",

            },

        },
        fleetAndRoute: {
            handleConfirm: {
                title: "Confirm Status Change",
                text: "Are you sure you want to change the driver's status?",
                text1: "Are you sure you want to change the status of the vehicle with license plate",
                text2: "Are you sure you want to change the status",
                text3: "of the driver-vehicle association",
                text4: "of the driver"
            },
            status: {
                "ACTIVE": "ACTIVE",
                "CANCELLED": "INACTIVE",

            },
            statusOnboarding: {
                verified: "Verified",
                ongoing: "Ongoing",
                request: "Request"
            },
            heading: "Fleet & Routes",
            filter: 'Filter',
            fleet: 'Fleet',
            registeredAssets: 'My Vehicles',
            drivers: 'Drivers',
            routes: 'Routes',
            allVehicles: 'All vehicles',
            emptyVehicles: 'There are no vehicles to show.',
            gridAssets: {
                plate: "Plate",
                vehicle: 'Vehicle Type',
                firstRegistrationYear: 'Registration Date',
                enviromentClass: 'Emission Class',
                fuelType: 'Fuel Type',
                emissionsData: 'Emissions Data',
                status: 'Vehicle Status',
                lastTraceabilityCheck: 'Last Traceability Check'
            },
            gridGroupedVehicles: {
                plate: "Plate",
                registrationDate: 'Registration Date',
                vehicleStatus: 'Vehicle Status',
                lastTraceabilityCheck: 'Last Traceability Check'
            },
            gridDrivers: {
                driver: 'Driver',
                phone: 'Phone',
                email: 'Email',
                plate: 'Plate',
                vehicleType: 'Vehicle Type',
                associationPeriod: 'Association Period',
                status: 'Association Status',
                lastLogin: 'Last Login App',
                appOnboardingRequest: 'App Onboarding Check',
                perform: 'Perform Onboarding Check',
                onboardingStatus: 'App Onboarding Request',
                lastAssociationUpdate: 'Last Association Update',
                driverStatus: 'Driver Status'

            },
            headerDriver: {
                driver: 'Driver',
                generalData: "General Data",
                name: 'Name',
                surname: 'Surname',
                lastLogin: 'Last Login App',
                phone: 'Phone',
                email: 'Email',
                driverStatus: 'Driver Status',
                lastUpdate: 'Last Update',
                onboarding: 'Onboarding',
                appOnboardingCheck: 'App Onboarding Check',
                checkOnboarding: 'Check Onboarding',
                requestOnboarding: 'Request Onboarding',
                editDriver: 'Edit Driver',
                addAssociation: 'Add Association',
                onGoing: 'Ongoing',
                request: 'Request',
                save: 'Save',
                cancel: 'Cancel',
                ftl: 'FTL',
                partitaIva: 'Carrier Code for Mobile App'

            },
            vehicles: {
                "3.5 ton van": "3.5 ton van",
                "Up to 7.5 ton truck": "Up to 7.5 ton truck",
                "Over 7.5 ton truck": "Over 7.5 ton truck",
                "Mega tautliner": "Mega tautliner",
                "Standard tautliner": "Standard tautliner",
                "Frigo": "Frigo",
                "Coil trailer": "Coil trailer",
                "Standard Truck": "Standard Truck",
                "Box": "Box",
                "Three axles truck": "Three axles truck",
                "Mega Truck": "Mega Truck",
                "Container trailer": "Container trailer",
                "Vehicle": "Vehicle",
                "Trailer": "Trailer",
                "INCOMPLETE": "Incomplete"

            },
            fuelType: {
                "CNG": "CNG",
                "Diesel": "Diesel",
                "Electric": "Electric",
                "Hybrid": "Hybrid",
                "LNG": "LNG"
            },

            tableHeaders: {
                category: 'Category',
                type: 'Type',
                number: 'Number'
            },
            tableHeadersRoutes: {
                from: 'From',
                to: 'to',
                type: 'Type',
                added: 'Added',
                action: 'Action'
            },
            from: 'From',
            to: 'to',
            roundtrip: 'Roundtrip',
            oneWay: 'One way',
            deleteRoute: 'Delete routes',
            loading: 'Loading...',
            modalDelete: {
                choseText: "Which routes do you want to delete?",
                text: "<strong>From {{country_from_name}} to {{country_to_name}}</strong>.",
                textSingleRoute: "You are deleting <strong>from {{country_from_name}} to {{country_to_name}}</strong> route.",
                confirmText: "Do you want to proceed?"
            },
            added: 'Added',
            emptyRoutes: "There are no routes to show.",
            toast: {
                associationStatusChanged: "Association status changed successfully",
                associationStatusChangeError: "Error changing association status",
                driverStatusChanged: "Driver status changed successfully",
                driverStatusChangeError: "Error changing driver status"
            },
            errorDialog: {
                driverRemoval: "Driver {{name}} deactivation is not possible because the driver is involved in the following trips:",
                vehicleRemoval: "Vehicle {{plate}} deactivation is not possible because the driver is involved in the following trips:",
                noteTitle: "Note from Arcese"
            }
        },
        settings: {
            heading: "Settings",
            email: "Email",
            phone: "Phone",
            role: "Role",
            properties: "Properties",
            accountAdministrator: "Account administrator",
            emptyContacts: "There are no contacts to show.",
            tableHeaders: {
                user: "User",
                email: "Email",
                phone: "Phone",
                role: "Role",
                properties: "Properties"
            },
            modalDeleteUser: {
                deleteUser: "Delete user",
                text: "You are deleting <strong>{{name}} {{surname}}</strong>. This action is not reversible.",
                confirmText: "Do you want to proceed?"
            },
            modalChangeAdmin: {
                changeAdmin: "Change Account Administrator",
                text: "You are making <strong>{{name}} {{surname}}</strong> account administrator. You will lose your role as administrator.",
                confirmText: "Do you want to proceed?",
                button: "Change admin"
            }
        },
        profile: {
            heading: "Profile",
            userProfile: "User profile",
            businessProfile: "Business profile",
            email: "Email",
            phone: "Phone",
            role: "Role",
            city: "City",
            zipCode: "Zip Code",
            address: "Address",
            vat: "VAT Number",
            taxcode: "Generic Tax Code",
            status: "Status",
            businessName: "Business name",
            pec: "Supplier Certified Email",
            marketingCheckboxLabel: "I authorize the processing of my data for marketing purposes",
            privacyCheckboxLabel: `I declare that I have read and accept the <a href='${settings.privacyUrlEN}' style='text-decoration: underline; color: #cf0a2c' target='_blank'>privacy policy</a>`,
            collaborationCheckboxLabel: "I consent to receive communications for future partnerships regarding new routes and services",
            variationEffectiveDate: 'Effective Date of Change',
            deteFormat: 'dd/mm/yyyy',
            selfacceptance: "Self Acceptance"
        }
    },
    components: {
        modalPdfDocuments: {
            loading: 'Loading...',
            errorLoadDocument: 'There was an error loading the document.',
            confirmButton: 'Confirm',
            viewFileFullPage: 'View file full page',
            previewNotDocx: "Preview not available for .docx files",
            download: "Download file"
        },
        modalPdfContracts: {
            loading: 'Loading...',
            errorLoadContract: 'There was an error loading the contract.',
            confirmButton: 'Confirm',
            viewFileFullPage: 'View file full page',
            previewNotDocx: "Preview not available for .docx files",
            download: "Download file",
            closeButton: "Close"
        },
        applicationError: {
            text: 'There was an error loading the application.',
            reload: 'Reload'
        },
        accountBlocked: {
            text: "Your account has been blocked and you cannot access the application. Please, contact Arcese support for more informations."
        },
        authorizationError: {
            text: 'There was an error authenticating the user.',
            reload: 'Retry authentication'
        },
        fleetGraphs: {
            noStats: "Stats on your fleet are not available."
        },
        profileDropDown: {
            profile: "Profile",
            logout: "Logout"
        },
        modalGeneralTerms: {
            viewFileFullPage: 'View file full page',
            checkboxLabel: "I've taken vision of the document and I accept the conditions",
            nameGeneralTerms: "General Terms",
            nameDriversRules: "DUVRI"
        }
    },
    errors: {
        genericErrorRequired: "Field {{label}} is required.",
        errorAcceptanceGeneralTerms: "Error during acceptance.",
        errorModalPdfCheckbox: "You have to check the confirmation checkbox to proceed.",
        errorUploadingDocument: "Error during upload of document.",
        errorElaboratingDocument: "Error during elaboration of document.",
        notSupportedDocument: "Not supported document type.",
        errorAddingServices: "Error adding services.",
        errorAddingContact: 'Error adding contact.',
        errorModifyingContact: "Error modifying contact.",
        errorCheckingAccountStatus: "Error checking account status.",
        errorCheckingGeneralTerms: "Error checking general terms and conditions.",
        errorAcceptingAddendum: "There was an error accepting the addendum.",
        errorUpdatingIbanSwift: "Error during update of the iban and/or the swift. The value(s) entered do not meet the expected format.",
        errorUpdatingSwift: "The length of the swift must be between 8 and 11 characters.",
        errorModifyingProfile: "Error modifying profile.",
        errorModifyingBusinessProfile: "Error modifying business profile.",
        errorDeletingContact: "Error deleting contact.",
        requiredCity: "City is required",
        requiredAddress: "Address is required",
        requiredBusinessName: "Business name is required",
        requiredVat: "VAT is required",
        requiredGenericTaxCode: "Generic Tax Code is required",
        requiredZipCode: "Zip code is required",
        requiredName: "Name is required",
        requiredSurname: "Surname is required",
        requiredEmail: "Email is required",
        requiredPhone: "Phone is required",
        incorrectFormatPhone: "Phone format is incorrect",
        requiredRole: "Role is required",
        incorrectFormatEmail: "Email format is incorrect",
        requiredConfirmEmail: "Confirm email is required",
        incorrectFormatConfirmEmail: "Confirm email format is incorrect",
        confirmEmailMustBeEqualToEmail: "Confirm email must be equal to email",
        errorReadNotification: "There was an error reading notification.",
        errorGetNotifications: "Error getting notifications.",
        requiredDocument: "The document is required.",
        errorDownloadTemplate: "There was an error obtaining template.",
        fileValidation: {
            unsupportedFormat: "Unsupported file format. Accepted formats: {{formats}}",
            fileTooLarge: "File too large. Maximum allowed size: {{maxSize}}",
            invalidFile: "Invalid file"
        }
    }
}